import { Button, Popover } from 'rsuite';
import styled from 'styled-components';

export const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin-top: 10px;
`;

export const RadioContainer = styled.div`
  display: flex;
`;

export const RadioLabel = styled.label`
  margin-left: 5px;
  font-size: 14px;
`;

export const StyledPopover = styled(Popover)`
  .rs-popover-title {
    font-size: 24px;
  }

  width: 450px;
  border-radius: 5px;
`;

export const Text = styled.p`
  font-size: 16px;
`;

export const Buttons = styled.div`
  display: flex;
  margin-top: 20px;
  gap: 20px;
`;

export const CloseButton = styled(Button)`
  width: 100px;
  height: 36px;
  border-radius: 6px;
  margin-right: 12px;
  border: solid 1px #101938;
  color: #101938;
`;

export const SendButton = styled(Button)`
  width: 100px;
  height: 36px;
  border-radius: 6px;
  color: white;
  background-color: #37a3bc;
`;
